/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPFREQUENCY } from './IAPFREQUENCY';
import {
    IAPFREQUENCYFromJSON,
    IAPFREQUENCYFromJSONTyped,
    IAPFREQUENCYToJSON,
} from './IAPFREQUENCY';
import type { IAPINCOMEOPTION } from './IAPINCOMEOPTION';
import {
    IAPINCOMEOPTIONFromJSON,
    IAPINCOMEOPTIONFromJSONTyped,
    IAPINCOMEOPTIONToJSON,
} from './IAPINCOMEOPTION';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface InvestmentDetailsRegularWithdrawalViewModel
 */
export interface InvestmentDetailsRegularWithdrawalViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    incomeId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    incomeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    incomePercentage?: number;
    /**
     * 
     * @type {Date}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    firstPaymentDate?: Date;
    /**
     * 
     * @type {IAPFREQUENCY}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    frequency?: IAPFREQUENCY;
    /**
     * 
     * @type {IAPINCOMEOPTION}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    incomeOption?: IAPINCOMEOPTION;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof InvestmentDetailsRegularWithdrawalViewModel
     */
    hasRegularWithdrawal: IAPYESORNO;
}

/**
 * Check if a given object implements the InvestmentDetailsRegularWithdrawalViewModel interface.
 */
export function instanceOfInvestmentDetailsRegularWithdrawalViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "hasRegularWithdrawal" in value;

    return isInstance;
}

export function InvestmentDetailsRegularWithdrawalViewModelFromJSON(json: any): InvestmentDetailsRegularWithdrawalViewModel {
    return InvestmentDetailsRegularWithdrawalViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsRegularWithdrawalViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsRegularWithdrawalViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'incomeId': !exists(json, 'IncomeId') ? undefined : json['IncomeId'],
        'incomeAmount': !exists(json, 'IncomeAmount') ? undefined : json['IncomeAmount'],
        'incomePercentage': !exists(json, 'IncomePercentage') ? undefined : json['IncomePercentage'],
        'firstPaymentDate': !exists(json, 'FirstPaymentDate') ? undefined : (new Date(json['FirstPaymentDate'])),
        'frequency': !exists(json, 'Frequency') ? undefined : IAPFREQUENCYFromJSON(json['Frequency']),
        'incomeOption': !exists(json, 'IncomeOption') ? undefined : IAPINCOMEOPTIONFromJSON(json['IncomeOption']),
        'hasRegularWithdrawal': IAPYESORNOFromJSON(json['HasRegularWithdrawal']),
    };
}

export function InvestmentDetailsRegularWithdrawalViewModelToJSON(value?: InvestmentDetailsRegularWithdrawalViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'IncomeId': value.incomeId,
        'IncomeAmount': value.incomeAmount,
        'IncomePercentage': value.incomePercentage,
        'FirstPaymentDate': value.firstPaymentDate === undefined ? undefined : (value.firstPaymentDate.toISOString()),
        'Frequency': IAPFREQUENCYToJSON(value.frequency),
        'IncomeOption': IAPINCOMEOPTIONToJSON(value.incomeOption),
        'HasRegularWithdrawal': IAPYESORNOToJSON(value.hasRegularWithdrawal),
    };
}

